import React, { useState, useEffect } from 'react'

const TodoList = () => {
  const [todos, setTodos] = useState([])
  const [newTodoTitle, setNewTodoTitle] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // 获取所有 todos
  const fetchTodos = async () => {
    try {
      setLoading(true)
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5174'
      const response = await fetch(`${apiUrl}/api/todos`, {
        credentials: 'include'
      })
      
      if (!response.ok) {
        throw new Error('获取 todos 失败')
      }
      
      const data = await response.json()
      setTodos(data)
      setError(null)
    } catch (err) {
      console.error('获取 todos 失败:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  // 创建新的 todo
  const handleAddTodo = async (e) => {
    e.preventDefault()
    
    if (!newTodoTitle.trim()) {
      return
    }
    
    try {
      setLoading(true)
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5174'
      const response = await fetch(`${apiUrl}/api/todos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ title: newTodoTitle })
      })
      
      if (!response.ok) {
        throw new Error('创建 todo 失败')
      }
      
      const newTodo = await response.json()
      setTodos([newTodo, ...todos])
      setNewTodoTitle('')
      setError(null)
    } catch (err) {
      console.error('创建 todo 失败:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  // 切换完成状态
  const handleToggleTodo = async (id, completed) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5174'
      const response = await fetch(`${apiUrl}/api/todos/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ completed: !completed })
      })
      
      if (!response.ok) {
        throw new Error('更新 todo 失败')
      }
      
      const updatedTodo = await response.json()
      setTodos(todos.map(todo => 
        todo.id === id ? updatedTodo : todo
      ))
      setError(null)
    } catch (err) {
      console.error('更新 todo 失败:', err)
      setError(err.message)
    }
  }

  // 删除 todo
  const handleDeleteTodo = async (id) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5174'
      const response = await fetch(`${apiUrl}/api/todos/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      })
      
      if (!response.ok) {
        throw new Error('删除 todo 失败')
      }
      
      setTodos(todos.filter(todo => todo.id !== id))
      setError(null)
    } catch (err) {
      console.error('删除 todo 失败:', err)
      setError(err.message)
    }
  }

  // 组件加载时获取 todos
  useEffect(() => {
    fetchTodos()
  }, [])

  return (
    <div style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px'
    }}>
      <h2 style={{
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, #FF6B6B 0%, #FFB88C 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
        待办事项 (React)
      </h2>

      {/* 添加 todo 表单 */}
      <form onSubmit={handleAddTodo} style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            value={newTodoTitle}
            onChange={(e) => setNewTodoTitle(e.target.value)}
            placeholder="添加新的待办事项..."
            disabled={loading}
            style={{
              flex: 1,
              padding: '10px',
              border: '2px solid #FF6B6B',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s'
            }}
          />
          <button
            type="submit"
            disabled={loading || !newTodoTitle.trim()}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #FF6B6B 0%, #FFB88C 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading || !newTodoTitle.trim() ? 0.5 : 1,
              transition: 'opacity 0.2s'
            }}
          >
            {loading ? '添加中...' : '添加'}
          </button>
        </div>
      </form>

      {/* 错误提示 */}
      {error && (
        <div style={{
          padding: '10px',
          marginBottom: '20px',
          background: '#fee',
          border: '1px solid #fcc',
          borderRadius: '8px',
          color: '#d00'
        }}>
          {error}
        </div>
      )}

      {/* Todo 列表 */}
      {loading && todos.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#666' }}>
          加载中...
        </div>
      ) : todos.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: '40px 0' }}>
          暂无待办事项
        </div>
      ) : (
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0
        }}>
          {todos.map((todo) => (
            <li
              key={todo.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px',
                marginBottom: '8px',
                background: 'white',
                border: '2px solid #FFB88C',
                borderRadius: '8px',
                transition: 'all 0.2s'
              }}
            >
              <input
                type="checkbox"
                checked={todo.completed}
                onChange={() => handleToggleTodo(todo.id, todo.completed)}
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                  accentColor: '#FF6B6B'
                }}
              />
              <span style={{
                flex: 1,
                fontSize: '14px',
                textDecoration: todo.completed ? 'line-through' : 'none',
                color: todo.completed ? '#999' : '#333'
              }}>
                {todo.title}
              </span>
              <button
                onClick={() => handleDeleteTodo(todo.id)}
                style={{
                  padding: '6px 12px',
                  background: '#ff4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#cc0000'}
                onMouseLeave={(e) => e.target.style.background = '#ff4444'}
              >
                删除
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* 统计信息 */}
      {todos.length > 0 && (
        <div style={{
          marginTop: '20px',
          padding: '10px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px'
        }}>
          总共 {todos.length} 项，已完成 {todos.filter(t => t.completed).length} 项
        </div>
      )}
    </div>
  )
}

export default TodoList
